import { SESSION_STORAGE_KEYS } from 'shared/sessionStorageUtils';
import { getLocaleString } from 'shared/utils/getLocaleString';
import useLocalStorage from './useLocalStorage';

const useLocale = () => {
  const { getValueFromLocalStorage } = useLocalStorage();
  
  const country = getValueFromLocalStorage(SESSION_STORAGE_KEYS.country);
  const language = getValueFromLocalStorage(SESSION_STORAGE_KEYS.language);

  const countryCode = country?.code;
  const languageCode = language?.value;

  return language && countryCode
    ? getLocaleString(languageCode, countryCode)
    : undefined;
};
export default useLocale;
